import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Intro } from './Intro';
import { Formulaire } from './Formulaire';

const useStyle = makeStyles({
    mainDiv:{
        display:'flex',
        flexDirection:'column',
        placeContent:'center',
      },
    column:{
        display:'flex',
        placeContent:'center',
        flexDirection: 'column'
    }
})

const App: React.FC = () => {

const classes = useStyle()

    return (
        <div className={classes.mainDiv} >
                <Intro/>
                <div className={classes.column}>
                    <Formulaire/>
                </div>
        </div>
    )
}

export default App;
